import NewRepoMessage from './NewRepoMessage';
import { repositoriesSelector } from 'state/selectors/repositories';
import { connect } from 'react-redux';
import { sensorAuthorizationsByIdSelector } from 'state/selectors/sensors-authorizations';

const mapStateToProps = state => {
  return {
    repositories: repositoriesSelector(state),
    sensorAuthorizationsById: sensorAuthorizationsByIdSelector(state)
  };
};

export default connect(mapStateToProps)(NewRepoMessage);
